import { render } from "./StageComp.vue?vue&type=template&id=61360579&scoped=true"
import script from "./StageComp.vue?vue&type=script&lang=js"
export * from "./StageComp.vue?vue&type=script&lang=js"

import "./StageComp.vue?vue&type=style&index=0&id=61360579&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61360579"]])

export default __exports__